export const CONSENT_TYPES = {
  bannedClose: "Accepted banned popup, clicked on 'Close'",
  bannedContinue: "Accepted banned popup, clicked on 'Continue'",
  redirectConfirm: "Accepted redirect popup, clicked on 'Confirm'",
  redirectDoNotConfirm: "Accepted redirect popup, clicked on 'Do not confirm'",
  cookie: "Accepted cookies:",
};
